import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxBrModule } from '@nbfontana/ngx-br';

import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { Routes, RouterModule } from '@angular/router';

import { ToastrModule, ToastrService } from 'ngx-toastr';

import { NavigationComponent } from './components/navigation/navigation.component';
import { ChangeModalComponent } from './components/change-password/change-password.component';
import { FormErrorComponent } from './components/form-error/form-error.component';
import { SpecialistCardComponent } from './components/specialist-card/specialist-card.component';

import { FinpassCoreModule } from 'finpass-angular-services';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { KeysPipe } from './pipes/keys.pipe';
import { environment } from './environments/environment';
import { OnboardingModalComponent } from './components/onboarding-modal/onboarding-modal.component';
import { FinpassUiModule } from 'finpass-ui';
import { NavigationProfileComponent } from './components/navigation-profile/navigation-profile.component';
import { NavigationEmitterService } from './services/NavigationEmitterService';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';

// attention when importing the icon because of a tree-shaking problem
// https://fontawesome.com/docs/apis/javascript/tree-shaking

import { faFileCertificate } from '@fortawesome/pro-solid-svg-icons/faFileCertificate';


library.add(faFileCertificate)

@NgModule({
  declarations: [
    NavigationComponent,
    ChangeModalComponent,
    FormErrorComponent,
    KeysPipe,
    SpecialistCardComponent,
    OnboardingModalComponent,
    NavigationProfileComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FinpassCoreModule.forRoot(environment),
    ToastrModule.forRoot({
        positionClass: 'toast-bottom-right',
    }),
    NgxBrModule.forRoot(),
    RouterModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    FinpassUiModule,
    FontAwesomeModule
   ],
   providers: [
       ToastrService,
       NavigationEmitterService
   ],
  exports: [
    NavigationComponent,
    ChangeModalComponent,
    FormErrorComponent,
    OnboardingModalComponent,
    KeysPipe,
    SpecialistCardComponent,
    NavigationProfileComponent
  ],
  entryComponents: [
    ChangeModalComponent,
    OnboardingModalComponent
  ]
})
export class FinpassComponentsModule {}
